import TopBar from "../user-topbar/UserTopbar";
import SideBar from "../user-sidebar/UserSidebar";
import { SalaryComponent } from "../../salary-summary/SalaryComponent";
import { fetchActionsUtil, useCookie } from "../../../utils";
import { useState, useEffect } from "react";
import { URLS } from "../../urls";
import { Dropdown } from "react-bootstrap";

function SalarySummary() {
  const [stateBranch, setStateBranch] = useState({
    id: "",
    name: "",
  });
  const [branches, setBranches] = useState([]);

  const branch_id = useCookie("branch_id");

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const branchData = await fetchActionsUtil(
          `${URLS.backendBranch}/get`,
          "GET"
        );

        setBranches(branchData.branches);
        const branch = branchData.branches?.find((el) => el._id === branch_id);

        setStateBranch({ id: branch?._id, name: branch?.name });
      } catch (error) {
        console.log(error);
      }
    };

    let isMounted = true;

    if (isMounted) {
      fetchBranches();
    }

    return () => {
      isMounted = false;
    };
  }, [branch_id]);

  const switchCompany = (item) => {
    setStateBranch({ id: item._id, name: item.name });
  };

  const SwitchCompanyComponent = () => {
    return (
      <div className="my-3 d-flex justify-content-end align-item-baseline">
        <Dropdown>
          <Dropdown.Toggle variant="white" bsPrefix={`toggle`}>
            {stateBranch.name || "Switch Company"}
          </Dropdown.Toggle>
          <Dropdown.Menu
            popperConfig={{
              strategy: "fixed",
            }}
            renderOnMount
          >
            {branches?.map((el) => (
              <Dropdown.Item
                key={el.name}
                as="button"
                className={`${stateBranch.id === el._id ? "active" : ""}`}
                onClick={() => switchCompany(el)}
              >
                {el.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <SalaryComponent
      TopBar={TopBar}
      SideBar={SideBar}
      branch_id={stateBranch.id}
      SwitchCompanyComponent={SwitchCompanyComponent}
    />
  );
}

export default SalarySummary;
